import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PreviewState {
  pastProducts: boolean;
}

const initialState: PreviewState = {
  pastProducts: false,
};

const previewSlice = createSlice({
  name: "preview",
  initialState,
  reducers: {
    setPastProducts(state, action: PayloadAction<boolean>) {
      state.pastProducts = action.payload;
    },
  },
});

export const { setPastProducts } = previewSlice.actions;
export default previewSlice.reducer;
